import React from "react"

function PPLoadingIndicator({ leftSide }) {
    return (
        <div className={"spinner-box d-flex m-3" + (leftSide ? " w-100" : " justify-content-center")}>
            <output className="spinner-border">
                <span className="visually-hidden">Loading...</span>
            </output>
        </div>
    )
}

export default PPLoadingIndicator
